import { render, staticRenderFns } from "./ConfigIndividualTuitionFee.vue?vue&type=template&id=783f5c79"
import script from "./ConfigIndividualTuitionFee.vue?vue&type=script&lang=js"
export * from "./ConfigIndividualTuitionFee.vue?vue&type=script&lang=js"
import style0 from "./ConfigIndividualTuitionFee.vue?vue&type=style&index=0&id=783f5c79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports